export const OPEN_PROGRESSNOTE_SAVE_MODEL = "OPEN_PROGRESSNOTE_SAVE_MODEL";
export const CLOSE_PROGRESSNOTE_SAVE_MODEL = "CLOSE_PROGRESSNOTE_SAVE_MODEL";
export const OPEN_PROGRESSNOTE_SAVE_DISCLAIMER_MODEL = "OPEN_PROGRESSNOTE_SAVE_DISCLAIMER_MODEL";
export const CLOSE_PROGRESSNOTE_SAVE_DISCLAIMER_MODEL = "CLOSE_PROGRESSNOTE_SAVE_DISCLAIMER_MODEL";
